import { render, staticRenderFns } from "./RequestedReminder.vue?vue&type=template&id=6d19b8e5&"
import script from "./RequestedReminder.vue?vue&type=script&lang=js&"
export * from "./RequestedReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports